<mat-progress-spinner
    class="ds-loading-spinner"
    mode="indeterminate"
    [ngClass]="['ds-loading-spinner--' + size, 'ds-loading-spinner--' + theme]"
    [style.color]="color"
    [diameter]="size | dsLoadingSpinnerMetric: 'diameter' : diameter"
    [strokeWidth]="size | dsLoadingSpinnerMetric: 'strokeWidth' : strokeWidth"
    [attr.aria-label]="ariaLabel"
></mat-progress-spinner>
